/**
 * New Chat Button Component (Mobile)
 *
 * Single responsibility: Render new chat button for mobile navbar
 */

import React from 'react';
import { NavbarIcon } from '../../shared/NavbarIcon';
import {
  brandColors,
  typographyColors,
  typography,
  fontPrimary,
} from '@/design-system/utils';

export interface NewChatButtonProps {
  onClick?: () => void;
  variant?: 'icon-only' | 'with-label';
}

export const NewChatButton: React.FC<NewChatButtonProps> = ({
  onClick,
  variant = 'with-label',
}) => {
  if (variant === 'icon-only') {
    return (
      <div
        style={{
          width: '24px',
          height: '24px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
        }}
      >
        <NavbarIcon iconName='plus' size={16} alt='New Chat' />
      </div>
    );
  }

  return (
    <button
      onClick={onClick}
      className='w-full py-3 rounded-lg flex items-center justify-center gap-2 hover:opacity-90 transition-opacity'
      style={{
        backgroundColor: brandColors.primary,
      }}
      aria-label='New Chat'
    >
      <NavbarIcon iconName='plus' size={20} alt='New Chat' />
      <span
        style={{
          fontFamily: fontPrimary,
          fontWeight: typography.weight.semibold,
          fontSize: typography.size.base,
          color: typographyColors.primary,
        }}
      >
        New Chat
      </span>
    </button>
  );
};
